import React from "react"
import { Link } from "react-router-dom"

const Item = ({ name, route }) => (
    < Link to={`/${route}`} className="main-nav-item" > {name}</Link>)

export default Item